import { useMutation, useQueryClient } from "react-query";
import InitApi from "api/InitApi";
import useTokenStore from "store/tokenStore";

export default function usePublishConfigurations() {
    const { accessToken } = useTokenStore();
    const queryClient = useQueryClient();
    return useMutation(async () => {
        const api = await InitApi({ accessToken });
        const response = await api.post("/publish-configurations");
        return response.data;
    }, {
        onSuccess: () => queryClient.invalidateQueries(["configs"]),
    });
}
